import React from 'react'
import PropTypes from 'prop-types'
import Paper from '@material-ui/core/Paper'
import { withStyles} from '@material-ui/core/styles'
import {
  Grid, Table, TableHeaderRow
} from '@devexpress/dx-react-grid-material-ui'

const styles = {
  customCell: {
    whiteSpace: "normal",
    wordWrap: "break-word"
  }
}

const CustomTableCellBase = ({ classes, ...restProps }) => (
  <Table.Cell className={classes.customCell} {...restProps} />
)

const CustomTableBase = ({ style, ...restProps }) => (
  <Table.Table
    style={{
      ...style,
      minWidth: 0
    }}
    {...restProps}
  />
)

const CustomTableCell = withStyles(styles)(CustomTableCellBase);
const CustomTable = withStyles(styles)(CustomTableBase);

class SettingsTable extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        { name: "numberColumn", title: "Parameter" },
        { name: "issueColumn", title: "Issue" },
      ],
      rows: [
        { numberColumn: '1.', issueColumn: 'The camera was deleted from the INSTAR Cloud, but is still added in the Alexa app' },
        { numberColumn: '2.', issueColumn: 'The cameras P2P information and/or camera username & password for this camera was not yet added in the INSTAR Cloud' },
        { numberColumn: '3.', issueColumn: 'P2P information and camera username & password were added, but Alexa was not authorized to use them (check camera configuration in your INSTAR Cloud account)' },
      ]
    };
  }
  render() {
    const { rows, columns } = this.state;

    return (
      <Paper style={{display: 'inline-block', maxWidth: '915px'}}>
        <Grid rows={rows} columns={columns}>
          <Table tableComponent={CustomTable} cellComponent={CustomTableCell} />
          <TableHeaderRow />
        </Grid>
      </Paper>
    );
  }
}

SettingsTable.propTypes = {
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(SettingsTable)
